export default __webpack_public_path__ + "static/media/knight01.9afeb8d8.jpg";